<template>
  <div
    :class="{
      'resource-center-bar flex-col items-start border-www-color-neutral-very-light py-30px pl-10 pr-5 md:border-b md:pl-11 md:pr-20': true,
      'text-www-color-white md:text-www-color-neutral-medium-dark': true,
      'bg-www-color-neutral-medium-dark md:bg-www-color-white': true,
    }"
  >
    <div>
      <h3
        :class="{
          'card-title mb-3 text-sm font-bold uppercase tracking-wider md:mb-4 md:text-lg': true,
        }"
      >
        {{ heading }}
      </h3>
      <p
        :class="{
          'resource-center-bar-p pb-4 text-10px font-medium leading-3 tracking-wider md:pb-18px md:text-xs md:leading-[14px] lg:max-w-[21.625rem]': true,
        }"
      >
        {{ description }}
      </p>
      <GeneralLink
        v-if="link"
        v-bind="link"
        :class="{
          'border-3px border-www-color-primary-lighter bg-www-color-transparent text-www-color-white md:bg-www-color-white md:text-www-color-primary-lighter': true,
          'hover:bg-www-color-primary-lighter hover:text-www-color-white focus:border-3px focus:border-www-color-accent-blue-light focus:bg-www-color-primary-lighter focus:text-www-color-primary-dark active:text-www-color-primary': true,
          'btn-link box-border rounded border-3px px-4 text-center font-ptc-Rajdhani text-15px font-bold uppercase leading-10 transition-all duration-300 md:text-18px md:leading-46px': true,
          'inline-block h-46px md:h-52px': true,
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { HighlightCorner } from '~/sanity/types';
import GeneralLink from './GeneralLink.vue';
defineProps<HighlightCorner>();
</script>

<style lang="scss" scoped></style>
